import React from "react";
import ChataSlider from "./ChataSlider";
import { WorkflowItemRightArrow } from "../common/Icon";
import Header from "../common/Header";

const ChataDescription = () => {
  const chataCard = JSON.parse(localStorage.getItem("items"));
  return (
    <>
      <div className="bg-white overflow-x-hidden shadow-my_contacts_tabs_shadow rounded-2xl 3xl:w-full  h-[calc(100vh-32px)] px-3 md:px-5">
        <div className=" overflow-hidden">
          <Header text="Chatavirsity" />
        </div>
        <div className="  py-6 flex flex-col lg:flex-row">
          <div className="max-w-full sm:max-w-[400px] l lg:max-w-[340px] 2xl:max-w-[410px] lg:pr-4 xl:pr-7">
            <img
              src={chataCard.chataimg1}
              alt="bolg description"
              className="w-full rounded-[13px]"
            />
            <p className="text-base font-semibold text-black italic mt-4 xl:mt-6">
              " {chataCard.chataheading2} "
            </p>
            <div className="px-2">
              <button className="w-full save_contact_btn text-[14px] !leading-normal font-semibold text-white rounded-[37px] border  border-solid  border-transparent  outline-none px-[10px]  py-[10px] bg-primary flex justify-center items-center hover:bg-white hover:border-primary hover:text-primary duration-200 mt-7">
                Buy now
                <span className="save_contact_arrow save_arrow pt-[3px]">
                  <WorkflowItemRightArrow />
                </span>
              </button>
            </div>
          </div>
          <div className="w-full mt-5 lg:mt-0 overflow-y-auto overflow_x_scroll_style h-full lg:h-[calc(100vh-170px)] overflow-x-hidden pr-2 xl:pr-20">
            <div className=" max-w-full sm:max-w-[640px] md:max-w-full lg:max-w-[600px] xl:max-w-[700px] 2xl:max-w-full">
              <h5 className="text-xl xl:text-2xl font-bold text-black">
                {chataCard.chataheading3}
              </h5>

              <p className="text-lg xl:text-xl font-normal italic text-black pt-2 sm:pt-3 xl:pt-6 mt-1">
                " {chataCard.chatapara} "
              </p>
              <p className="text-sm font-normal text-black pt-3 sm:pt-5 xl:pt-10">
                {chataCard.chatapara3}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {chataCard.chatapara4}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {chataCard.chatapara5}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {chataCard.chatapara6}
              </p>
            </div>
           <div className=" max-w-full sm:max-w-[640px] md:max-w-full lg:max-w-[600px] xl:max-w-[700px] 3xl:max-w-[1000px] min-[1800px]:max-w-[1200px] pt-5 xl:pt-12">
              <ChataSlider />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChataDescription;
